var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "container-m" },
    [
      _c("page-title", {
        staticClass: "page-title",
        attrs: { title: "Vorgänge für GCS" }
      }),
      _vm._v(" "),
      _c("v-divider", { attrs: { id: "end-divider" } }),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        {
          staticClass: "expansion-panel",
          attrs: { focusable: "", expand: "" },
          model: {
            value: _vm.panel,
            callback: function($$v) {
              _vm.panel = $$v
            },
            expression: "panel"
          }
        },
        _vm._l(_vm.dropdownTitles, function(item, i) {
          return _c(
            "v-expansion-panel-content",
            {
              key: i,
              attrs: { id: "expansion-panel" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "actions",
                    fn: function() {
                      return [
                        _c("v-icon", { staticClass: "icon-exppand" }, [
                          _vm._v("$vuetify.icons.expand")
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "header",
                    fn: function() {
                      return [_c("div", [_vm._v(_vm._s(item))])]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              i === 0
                ? _c("open-cases-table", {
                    attrs: { "case-data": _vm.openCases, gcs: true },
                    on: { expandAttendanceOpenCase: _vm.expandAttendanceCase }
                  })
                : i === 1
                ? _c("close-cases-table", {
                    attrs: { "case-data": _vm.closedCases, gcs: true },
                    on: { expandAttendanceCloseCase: _vm.expandAttendanceCase }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }